import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from "@/main/services/reducerUtils";
import { InsurerState } from "./insurerTypes";

export const useInsurerReducer = (keyReducer: string = "default") => {
	const returnSelector = useSelector((state: ApplicationState) => state.insurer);
	if (keyReducer === "default") return returnSelector as IReducerWithIsolated<InsurerState>;

	const updateState = {
		...returnSelector,
		isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA,
	};

	return updateState as IReducerWithIsolated<InsurerState>;
};
